import Home from 'pages/admin/Home';
import Users from 'pages/admin/Users';
import SolicitudesDatosPage from 'pages/admin/SolicitudesDatos';
import MisDatosPage from 'pages/MisDatos';
import Client from 'pages/admin/Client';
import TenantsPage from 'pages/admin/TenantsPage';
import Folders from 'pages/admin/Folders/Folders';
import BudgetPageContainer from 'Containers/BudgetPageContainer/BudgetPageContainer';
import MaintanceReportsAdmin from 'pages/admin/MaintanceReports/MaintanceReports';
import Certificacion from 'pages/admin/Certificacion';
import AddCertification from 'Containers/AddCertification';
import CertificationDetail from 'components/applications/CertificationDetail';
import DatosCliente from 'pages/DatosCliente';
import Mantencion from 'pages/Specialist/mantenciones/Mantencion';
import Category from 'pages/admin/Maintance/Category';
import Activities from 'pages/admin/Maintance/Activities';
import Asignations from 'pages/admin/Maintance/Asignations';
import Mantenciones from 'pages/admin/Mantenciones';
import Administradores from 'pages/admin/Administradores';
import MantencionesCalendario from 'pages/admin/MantencionesCalendario';
import IDClientePage from 'pages/admin/IDClientePage/IDClientePage';
import ColeccionesPage from 'pages/admin/ColeccionesPage/ColeccionesPage';
import IDColeccionPage from 'pages/admin/ColeccionesPage/IDColeccionPage';
import DocumentComposerPage from 'pages/admin/ColeccionesPage/DocumentComposerPage';
import ItemsColeccionPage from 'pages/admin/ColeccionesPage/ItemsColeccionPage';
import Documentos from 'pages/admin/Documentos/Documentos';
import PanelOperacionalPage from 'pages/admin/PanelOperacional/PanelOperacionalPage';
import HallazgosPageGlobal from 'pages/admin/HallazgosPage';
import TecnicosPage from 'pages/admin/Tecnicos/TecnicosPage';
import ReportesVisitaPage from 'pages/admin/ReportesVisita/ReportesVisitaPage';
import ReporteVisitaViewer from 'components/ReporteVisita/Viewer/ReporteVisitaViewer';
import TicketsPage from 'pages/admin/Tickets/TicketsPage';
import CicloPage from 'pages/admin/CicloPage/CicloPage';
import ODTGanttPage from 'pages/admin/ODTGantt/ODTGanttPage';
import CorreosPage from 'pages/admin/Correos/CorreosPage';

import { mainRoute, catchAllRoute } from '../helpers';

const ejecutivoRoutes = [
  mainRoute('/admin/tickets', TicketsPage),
  mainRoute('/admin/correos', CorreosPage),
  mainRoute('/admin/panel-operacional', PanelOperacionalPage),
  mainRoute('/admin/ciclo', CicloPage),
  mainRoute('/admin/tecnicos', TecnicosPage),
  mainRoute('/admin/reportes-visita', ReportesVisitaPage),
  mainRoute('/admin/reportes-visita/:id', ReporteVisitaViewer),
  mainRoute('/admin/hallazgos', HallazgosPageGlobal),
  mainRoute('/admin/users', Users),
  mainRoute('/admin/presupuestos/:id/documentos', Documentos),
  mainRoute('/admin/administradores', Administradores),
  mainRoute('/admin/mantenciones', Mantenciones),
  mainRoute('/admin/colecciones', ColeccionesPage),
  mainRoute('/admin/colecciones/:id', IDColeccionPage),
  mainRoute('/admin/colecciones/:id/items/:itemId', ItemsColeccionPage),
  mainRoute('/admin/document-composer/:id/:tipoDocumento', DocumentComposerPage),
  mainRoute('/admin/mantenciones/calendario', MantencionesCalendario),
  mainRoute('/admin/mantenciones/:id', Mantencion),
  mainRoute('/admin/maintance/asignations', Asignations),
  mainRoute('/admin/mantenciones/actividades', Activities),
  mainRoute('/admin/maintance/categories', Category),
  mainRoute('/admin/maintanceReports', MaintanceReportsAdmin),
  mainRoute('/admin', Home),
  mainRoute('/', Home),
  mainRoute('/admin/budget', BudgetPageContainer),
  mainRoute('/admin/client', Client),
  mainRoute('/admin/tenants', TenantsPage),
  mainRoute('/admin/client/:id/datos', DatosCliente),
  mainRoute('/admin/clientes/:id', IDClientePage),
  mainRoute('/admin/odt/:idOrder/gantt', ODTGanttPage),
  mainRoute('/admin/folders', Folders),
  mainRoute('/admin/certificacion', Certificacion),
  mainRoute('/admin/certificacion/nueva', AddCertification),
  mainRoute('/admin/certificacion/:id', CertificationDetail),
  // Ley 21.719: la bandeja la opera el tenant, que es el responsable de esos datos.
  // El backend además exige el rol (denyTypes en api/index.js): esconderla acá no alcanza.
  mainRoute('/admin/solicitudes-datos', SolicitudesDatosPage),
  mainRoute('/mis-datos', MisDatosPage),
  catchAllRoute(),
];

export default ejecutivoRoutes;
